import { render, staticRenderFns } from "./EmptyModalBase.vue?vue&type=template&id=eff23972&scoped=true&"
import script from "./EmptyModalBase.vue?vue&type=script&lang=js&"
export * from "./EmptyModalBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff23972",
  null
  
)

export default component.exports